const Facilities = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
  >
    <path
      d="M12.3379 15.75C11.9052 16.5561 11.2901 17.2501 10.5418 17.7765C9.79347 18.3029 8.93253 18.6472 8.02758 18.7821C7.12263 18.917 6.19869 18.8386 5.32938 18.5532C4.46007 18.2679 3.66942 17.7835 3.02043 17.1385C2.37144 16.4936 1.88205 15.706 1.59126 14.8385C1.30046 13.971 1.21629 13.0476 1.34547 12.1418C1.47464 11.236 1.81359 10.3729 2.33529 9.62132C2.857 8.86969 3.54704 8.2503 4.35044 7.8125"
      stroke="#444444"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.32539 2.12501C7.32539 2.65659 6.89446 3.08751 6.36289 3.08751C5.83132 3.08751 5.40039 2.65659 5.40039 2.12501C5.40039 1.59344 5.83132 1.16251 6.36289 1.16251C6.89446 1.16251 7.32539 1.59344 7.32539 2.12501Z"
      fill="#444444"
      stroke="#444444"
      strokeWidth="1.25"
    />
    <path
      d="M6.31299 4.7375L6.45049 11.95H11.8755L15.013 15.75H16.7005"
      stroke="#444444"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.4126 7.0375L11.5626 7.0375"
      stroke="#444444"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Facilities;
